import {
  Component,
  Input,
  EventEmitter,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { TotalCount } from '../search.interface';
import { FILTER_SECTION } from '../search.component';

@Component({
  selector: 'ft-search-results-investor',
  templateUrl: './search-results-investor.component.html',
  styleUrls: ['./search-results-investor.component.scss'],
})
export class SearchResultsInvestorComponent implements OnInit {
  @Input() results: [];
  @Input() totalCount: TotalCount["investor"];
  @Input() valueToShow: number;
  @Input() isViewAll: boolean;
  @Output()
  viewAllClick: EventEmitter<string> = new EventEmitter<string>();
  @Output()
  loadMoreFunds: EventEmitter<object> = new EventEmitter<object>();
  queryParams: Params;

  constructor(private activatedRoute: ActivatedRoute) {}

  ngOnInit(): void {
    this.queryParams = this.activatedRoute.snapshot.queryParams;
  }

  loadMore(event): void {
    this.loadMoreFunds.emit({ event, type: 'investor' });
  }

  clickEvent(event): void {
    this.isViewAll = true;
    this.viewAllClick.emit(FILTER_SECTION.investorFilterSection);
  }
}
